<template>
    <div class="vtht table-container">
      <table border="1" class="table" is-bordered is-fullwidth>
        <thead>
        <tr class="has-text-weight-bold">
          <th>MÙA</th>
          <th colspan="2">THÁNG</th>
          <th class="color_moc">Giáp - Ất</th>
          <th class="color_hoa">Bính - Đinh</th>
          <th class="color_tho">Mậu - Kỷ</th>
          <th class="color_kim">Canh - Tân</th>
          <th class="color_thuy">Nhâm - Quý</th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="(item, index) in data.time"
          :key="index"
        >
          <template v-if="index === 0">
            <td :rowspan="numspan" class="has-text-weight-bold" :class="data.muaCss">{{ data.mua }}</td>
            <td :rowspan="numspan">
              <span class="is-uppercase has-text-weight-bold" :class="data.css">{{ data.tenChi }}</span> <br/>
              <span class="has-text-weight-bold">({{ data.tk }})</span>
            </td>
          </template>
          <td style="width: 115px;">
            Từ ngày {{ item.min }} - {{ item.max }} <br/>
            <span :class="item.css">({{ item.tenCan }} {{ item.tenHanh }})</span>
          </td>
          <td
            v-for="(item2, index2) in data.can[index]"
            :key="index2"
          >
            {{ item2 }}
          </td>
        </tr>

        <tr>
        </tr>
        </tbody>
      </table>
    </div>
</template>

<script>
export default {
  name: 'VuongTuongHuuTu',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    numspan () {
      return this.data.time.length ?? 0
    }
  }
}
</script>

<style scoped>
  .vtht {
    max-width: 738px;
    margin: 0 auto;
  }
  .vtht table {
    width: 100%;
    background-color: rgba(225, 225, 225, 0.6);
  }

  td, th {
    width: 90px;
    height: 60px;
    text-align: center;
  }

  .table td, .table th {
    border: 1px solid black !important;
    border-width: 0 0 1px;
    padding: 0 !important;
    text-align: center !important;
    vertical-align: middle !important;
  }

</style>
